angular.module('rjmNg.directives').directive "exportApi", [
  () ->
    restrict: "E"
    templateUrl: "directive.exportApi.html"
    replace: true
    controllerAs: 'view'
    scope: true
    bindToController: true
    controller: [
      "$clientAppUrl"
      ($clientAppUrl) ->

        view = @

        view.importConnectionUrl = $clientAppUrl("/settings/connection/create/import/")

        view
    ]
]
